export default __webpack_public_path__ + "static/media/testes-java.df59446e.png";